import { useRegistrationStore } from '../../hooks';
import { TaskHeaderView } from '../../components/TaskHeaderView';

export const TaskHeader = () => {
  const { onOpenModal } = useRegistrationStore();

  return <TaskHeaderView handleClickRegistration={onOpenModal} />;
};
